module.exports = __webpack_public_path__ + "static/shotlists_takes@2x-2a7050e6b78a245481079a3a6938f533.png";